












































import {Vue, Component} from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import Table from "@/components/Table.vue";
import ActionButton from "@/components/Button/ActionButton.vue";
import axios from "@/utils/axios";

const ERROR_MESSAGE_MAP: Record<string, string> = {
  "Not enough learning activity to generate a prediction.": "Unvollständige Daten (#1)",
  "Student data is incomplete or invalid for prediction.": "Unvollständige Daten (#2)",
  "After filtering, all answers were eliminated!": "Unvollständige Daten (#3)",
  "not enough values to unpack (expected 5, got 4)": "Unerwartete Ausnahme (#1)",
};

@Component({
  components: {
    FscSimpleCard,
    Table,
    ActionButton,
  },
})
export default class KiPilotTheorieTable extends Vue {
  public isLoading = false;

   public tableItems: any[] = [];

  private tableFields = [
    {
      key: "studentName",
      label: "Name",
      sortable: false,
    },
    {
      key: "result",
      label: "Ergebnis",
      sortable: false,
    },
    {
      key: "nextTheoryExamDate",
      label: "Nächste Theorieprüfung",
      sortable: false,
    },
    {
      key: "errorMessage",
      label: "Fehlermeldung",
      sortable: false,
    },
    {
      key: "actions",
      label: "",
      sortable: false,
    },
  ];

  public async loadData(url: string): Promise<void> {
    this.isLoading = true;
    try {
      const response = await axios.post(url);
      this.tableItems = response.data;
    } finally {
      this.isLoading = false;
    }
  }

  public onRowClicked(item: any): void {
    this.$emit("row-clicked", item);
  }

  public onInsightsClicked(item: any): void {
    if (!item?.studentEducationId) return;
    this.$emit("insights-clicked", item);
  }

  public formatErrorMessage(message: string): string {
    return ERROR_MESSAGE_MAP[message] || message;
  }
}
